<template>
  <section>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('addEditCommande.lieuLivraison.title') }}</p>
      </header>
      <div class="card-content">
        <qd-collapse
          class="mgt-20px has-background-table-second-color pd-4"
          v-for="(ligne ,index) in commande.lignesCommande"
          :key="index"
          animation="slide">
          <template #trigger="props">
            <div class="level">
              <div class="level-left width-67">
                <div class="columns width-100percent">
                  <span class="column is-3">
                    <p>
                      <strong>
                        {{$t('addEditCommande.lieuLivraison.table.produit')}}
                      </strong>
                    </p>
                    {{ ligne.produit.reference }}
                  </span>
                  <span class="column is-3">
                    <p>
                      <strong>
                        {{$t('addEditCommande.lieuLivraison.table.libelle')}}
                      </strong>
                    </p>
                    {{ ligne.libelle }}
                  </span>
                  <span class="column is-3">
                    <p>
                      <strong>
                        {{$t('addEditCommande.lieuLivraison.table.quantite')}}
                      </strong>
                    </p>
                    {{ ligne.quantite}}
                  </span>
                  <span class="column is-3">
                    <p>
                      <strong>
                        {{$t('addEditCommande.lieuLivraison.table.lieuLivraison')}}
                      </strong>
                    </p>
                    {{ ligne.lieuxLivraisons.length}}
                  </span>
                </div>
              </div>
              <a class="level-right"
                :aria-expanded="props.open">
                <b-icon
                  :icon="!props.open ? 'chevron-right' : 'chevron-down'">
                </b-icon>
              </a>
            </div>
          </template>
          <lieu-de-livraison-tab-child-row :ligne="ligne" />
        </qd-collapse>
      </div>
    </div>
  </section>
</template>

<script>
import qdCollapse from '@/components/qdEncapsulation/qdCollapse';
import lieuDeLivraisonTabChildRow from './lieuDeLivraisonTabChildRow';

export default {
  components: {
    lieuDeLivraisonTabChildRow,
    qdCollapse,
  },
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getSumLignes(row, field) {
      return row.lignes.reduce((a, l) => a + l[field], 0);
    },
  },
};
</script>

<style>
</style>
